import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TuneIcon from '@material-ui/icons/Tune';

import styles from './styles';

const useStyles = makeStyles(styles);

/** Canonical list-page toolbar row: `[search] [Filters] [actions]`. */
const PageToolbar = ({
  search,
  onFiltersClick,
  filtersLabel,
  children,
  className,
  dense,
  searchWidth,
}) => {
  const classes = useStyles({ searchWidth });

  return (
    <div className={classnames(classes.root, dense && classes.dense, className)}>
      <div className={classes.search}>{search}</div>
      {onFiltersClick && (
        <Button
          variant="contained"
          color="secondary"
          className={classes.filtersButton}
          onClick={onFiltersClick}
          disableTouchRipple
        >
          <TuneIcon className={classes.filtersIcon} />
          <span className={classes.filtersLabel}>{filtersLabel}</span>
        </Button>
      )}
      {!!searchWidth && <div className={classes.spacer} />}
      {children}
    </div>
  );
};

PageToolbar.propTypes = {
  search: PropTypes.node,
  onFiltersClick: PropTypes.func,
  filtersLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dense: PropTypes.bool,
  searchWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PageToolbar.defaultProps = {
  search: null,
  onFiltersClick: undefined,
  filtersLabel: 'Filters',
  children: null,
  className: undefined,
  dense: false,
  searchWidth: undefined,
};

export default PageToolbar;
